import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Apply2 from "./commons/Apply2";
import AkilCall from "./commons/AkilCall";
import Swimming from "../icons/swimming-pool-installation-capetown.png"
import Download from "../icons/download-case-study.png"
import Icone from "../icons/icon-software.png";
import Khloe from "../icons/khloe-home-decor-zimbabwe.png"
import Carports from "../icons/carports-capetown.png"
import Eastgate from "../icons/eastgate.png"
import TopFooter from "./commons/TopFooter";
import icon4 from "../icons/digital-transformation-problems.jpg";
import Webdev from "../icons/website-development.png";
import GoogleAd from "../icons/google-ads-agency.png";
import DigitalMarketing from "../icons/digital-marketing.png";
import KhloHome from "../Case-studies/khloe-home-decor.pdf";
import CarportCape from "../Case-studies/carport-capetown.pdf";
import SwimmingPool from "../Case-studies/swimming-pool-installation-capetown.pdf";
import EastgateDental from "../Case-studies/eastgate-dental.pdf";
const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <main>
      {/* <!-- Slider Area Start--> */}
      <div className="slider-area">
        <div className="single-sliders slider-height d-flex align-items-center">
          <div className="container position-relative">
            <div className="row align-items-center">
              <div className="col-xl-6 col-lg-7 col-md-7">
                <div className="hero-caption">
                  <h2 className="text-white">Is Your Digital Growth Or Transformation Dream Out Of Reach?</h2>

                  <p>
                   Most businesses or organisations in Zimbabwe struggle to launch digital/software
                    products , increase visibilty and get clients online. Without
                   user or customer-centricity, the right software product or website
                    is never made. Let’s collaborate
                    to achieve success
                  </p>
                  <a href="https://calendly.com/mushaitapiwanashe/briefing-session" className="btn mt-20">
                    Schedule A Consultation With Us
                  </a>
                </div>
              </div>
              {/* <!-- hero shape 2--> You may have found your people*/}
              <div className="hero-shape">
                <img src="assets/img/hero/hero-img.png" height={30} alt="" />
              </div>
            </div>
          </div>
        </div>


        {/* <!-- social --> */}
      </div>

      {/* <!-- Slider Area End -->
    <!-- Services Area Start --> */}

      <section className="categories-area section-padding">
        <div className="container">
          <div className="row justify-content-center categories-area section-padding">

            <h1 class="text-center">Your Digital Growth Partners </h1>
            <p>Struggling to grow your business or transform your organisation in today's digital world?
               
 We help Zimbabwean businesses build, transform, and grow through our Digital Growth Strategy & Transformation Framework. We start by understanding your business, identifying growth opportunities, and creating a clear digital roadmap.
  We work as your digital growth partners, an extension of your team helping you transform, grow, and
   compete in a digital-first economy.
</p>
          </div>
          </div>

      </section>
       <section className="categories-area section-padding">
        <div className="container">
          
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-6">
              <div className="single-cat text-center mb-20">
                <div className="cat-icon">
                  <img src="assets/img/icon/custom.png" alt="" />
                </div>
                <div className="cat-cap">
                  <h5>
                    <a href="https://calendly.com/mushaitapiwanashe/briefing-session">Digital Strategy Framework</a>
                  </h5>
                  <p>

If customers can’t find you online, they’ll find someone else. We help Zimbabwean businesses fix weak digital footprints, improve visibility, and build a clear digital growth strategy that turns attention into customers.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6">
              <div className="single-cat text-center mb-20">
                <div className="cat-icon">
                  <img src={GoogleAd} alt="" />
                </div>
                <div className="cat-cap">
                  <h5>
                    <a href="https://calendly.com/mushaitapiwanashe/briefing-session">Become Our Digital Growth Partner</a>
                  </h5>
                  <p>
Digital growth should not be left to guesswork. We become an extension of your team, helping you plan, execute, improve, and measure your digital growth through strategic sessions, ongoing support, and clear performance reports.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6">
              <div className="single-cat text-center mb-20">
                <div className="cat-icon">
                  <img src="assets/img/icon/webservices.png" alt="" />
                </div>
                <div className="cat-cap">
                  <h5>
                    <a href="services">Website Development, Maintenance & Hosting </a>
                  </h5>

                  <p>

 Your website should bring business, not lose it. We develop, host, and maintain professional websites that are easy to find, trust, and navigate; turning visitors into customers.
</p></div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6">
              <div className="single-cat text-center mb-20">
                <div className="cat-icon">
                  <img src="assets/img/icon/ux.png" alt="" />
                </div>
                <div className="cat-cap">
                  <h5>
                    <a href="services">Automations & Chatbots </a>
                  </h5>
                  <p>
Too many enquiries and not enough time? Customers want answers now. Our AI chatbots respond instantly, capture leads, and help turn enquiries into sales                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </section>
     
      
         <section className="services-area2 section-padding2">
        <div className="container">
          
          <div className="row align-items-center justify-content-between">
            <div className="col-xl-5 col-lg-5 col-md-6 col-sm-11">
              {/* <!-- Section Tittle --> */}
              <div className="section-tittle section-tittle2 mb-55">
                <span>The guaranteed formula </span>
                <h2>CLARITY IN THE CHAOS</h2>
              </div>
            </div>

            <div className="col-xl-5 col-lg-5 col-md-6 col-sm-11">
              {/* <!-- Section Tittle -<p>
                    Many people and businesses wish to get clients through their website .It is a wish come true to comeacross a company that can assist and convert website traffic to customers.Are you on the first page of the search engine results pages (SERPs) for keywords that match your business or brand? If not, you’re missing out on valuable leads. Search engine optimization isn’t a fad and it’s no longer an option to simply not think about it if you want to grow your business. Let's push your website to the top of Google (organically). Get MORE leads and spend LESS money on Google Ads!.
                  </p>-> */}
              <div className="section-tittle section-tittle2 mb-55">
                <p>
                  Feeling swamped with all the tech talk? We're here to translate so you can get back to business. You might think "Is this even for me? I'm not a tech person". Don't worry, we're not just consultants; we're your business digital growth , partners, providing tailored strategies in plain English.
                </p>
              </div>
            </div>
          </div>
          <div class="row  section-title mt-20">
            <div class="col-md col-lg-12">
              <h2 className="text-white">1. Start with 'Why?'</h2>
              <p className="text-white">
                Our first step in designing the perfect solution is to fully grasp your business objectives
                and your customers' needs. This enables us to accurately define the problem at hand and your expectations ensuring that we
                are on the right track. By collaborating in this way, we are able to uncover
                your current position. Our ultimate goal is not just to help your business survive, but
                to see it thrive.
              </p>
            </div></div>
          <div class="row  section-title mt-20">
            <div class="col-md col-lg-12">
              <h2 className="text-white">2. Then get building!</h2>
              <p className="text-white">
                By harnessing the power of Design Thinking and incorporating user experience best practices, we craft impactful and effective digital strategies, tech products, custom software, and websites. Our innovative approach ensures scalability and promotes efficient growth. We understand the importance of establishing a strong emotional connection between your digital products and your target audience. After all, humans are emotional creatures and it is crucial for your software product or online presence to resonate with them.
              </p>
            </div></div>
          <div className="row">
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="single-cat mb-30 text-center">
                <div className="cat-icon">
                  <img src="assets/img/icon/stack1.svg" alt="" />
                </div>
                <div className="cat-cap">
                  <h5>
                    <a href="https://calendly.com/mushaitapiwanashe/briefing-session">Schedule a Meeting</a>
                  </h5>
                  <p>It all begins with understanding what you need.  <a href="https://calendly.com/mushaitapiwanashe/briefing-session">Book a briefing session</a> with us where we dissect your current digital challenges and understand what are you looking into our services.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="single-cat mb-30 text-center">
                <div className="cat-icon">
                  <img src="assets/img/icon/stack2.svg" alt="" />
                </div>
                <div className="cat-cap">
                  <h5>
                    <a href="#r">Get a Custom Digital Strategy</a>
                  </h5>
                  <p>We’ll develop a unique plan to navigate the digital hurdles or challenges  specific to your business.An  Blueprint of the next action points , user stories and flows , customer profiles and trajectory to your digital sucess </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="single-cat mb-30 text-center">
                <div className="cat-icon">
                  <img src="assets/img/icon/stack3.svg" alt="" />
                </div>
                <div className="cat-cap">
                  <h5>
                    <a href="#r">Hit Your Business Milestones</a>
                  </h5>
                  <p>Implement the plan and watch your digital dream come to live or  business grow, hitting targets and exceeding expectations</p>
                </div>
              </div>
            </div>


            <div className="row justify-content-center">
              <div className="col-xl-12">
                <div className="section-tittle section-tittle3 text-center pt-35">
                  <p>
                    Need a Technology support or to discuss a project ?We help you sift through all the tech jargon and focus on what will actually help your business grow.{" "}
                    <a href="https://calendly.com/mushaitapiwanashe/briefing-session">Get Started Now</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <h2 className="text-center">
              <strong>Why Choose Us - The Akiltech Difference</strong>
            </h2>
            <h5 className="text-center">Experience digital done right—focused, flexible, and built for what’s next.</h5>
      <div className="row mt-5">
       
        <div id="reasons" className="col-lg-6 reasons">
          <h3 className="text-center">
            {" "}
            <strong>Us </strong>{" "}
          </h3>

          <div class="col-12">
            <div class="service-box">
              <img src={Icone} height="30" />{" "}
              <div class="service-content">
                <h4>Power in your corner</h4>
                <p>
                  <strong>
                    We become an extension of your team, prioritizing your
                    unique business needs.
                  </strong>{" "}
                </p>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="service-box">
              <img src={Icone} height="30" />
              <div class="service-content">
                <h4>Expertise Built on Decades</h4>
                <p>
                  <strong>
                    A single point of contact, proven processes, and seasoned
                    pros to plan and build your site.
                  </strong>
                </p>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="service-box">
              <img src={Icone} height="30" />
              <div class="service-content">
                <h4>Transparent Communication</h4>
                <p>
                  <strong>
                    Regular updates and visible results keep you informed and
                    confident.
                  </strong>
                </p>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="service-box">
              <img src={Icone} height="30" />
              <div class="service-content">
                <h4>Future-Ready Strategy</h4>
                <p>
                  <strong>
                    We map out a clear, actionable roadmap for your growth,
                    ensuring you’re prepared for what’s next.
                  </strong>
                </p>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="service-box">
              <img src={Icone} height="30" />
              <div class="service-content">
                <h4>Tailored Solutions</h4>

                <p>
                  <strong>
                    We'll show you exactly what you need to level up your game
                    quickly and efficiently.
                  </strong>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <h3 className="text-center">
            <strong>Them</strong>{" "}
          </h3>

          <div class="col-12">
            <div class="service-box">
              <img src={Icone} height="30" />{" "}
              <div class="service-content">
                <h4>Volume Over Value</h4>
                <p>
                  <strong>
                    Treat clients as numbers with a one-size-fits-all mindset
                    leaving you lost in the system.
                  </strong>{" "}
                </p>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="service-box">
              <img src={Icone} height="30" />
              <div class="service-content">
                <h4>Inexperience Prevails</h4>
                <p>
                  <strong>
                    Makeshift solutions that cost more in time and resources
                    without delivering depth or value.
                  </strong>
                </p>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="service-box">
              <img src={Icone} height="30" />
              <div class="service-content">
                <h4>Ghost you</h4>
                <p>
                  <strong>
                    Weeks or months without updates, leaving you in the dark.
                  </strong>
                </p>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="service-box">
              <img src={Icone} height="30" />
              <div class="service-content">
                <h4>Lack Vision</h4>
                <p>
                  <strong>
                    A glaring absence of growth strategy, with no foresight or
                    planning for your business’s future.
                  </strong>
                </p>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="service-box">
              <img src={Icone} height="30" />
              <div class="service-content">
                <h4>Upsell Obsession</h4>

                <p>
                  <strong>
                    Focused on selling the latest fad, not what best serves your
                    business.
                  </strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      </section>
      {/* <div className="container-fluid call-bg">

        {/* <!-- Section Tittle --><p>
                    There are hundreds, maybe even thousands of website designers in Cape Town and it is often very difficult for you to know which web design company to go for. You may think “I need to find website designers near me” or finding affordable website designers is your priority.It is important that your design communicates the correct information, and that the user-experience is a seamless one.s a framework to help understand our client's or prospect's needs, and their business problem so that we can properly architect an appropriate solution.
                    Need an affordable web designer or web development company to accurately represent your brand? Look no further! Click below to get a web design quote today. </p>
                 *
        <div className="section-tittle call-action text-center mt-5 mb-60">
          <h2 className="text-white">A Partner of Choice for Digital Era Like No Other, Let's Collaborate
            To Achieve Success </h2>
  {/*
        <section>
        <div class="slider-logo">
            <div class="slider-items-logo">
                
                <img src="https://upload.wikimedia.org/wikipedia/en/thumb/3/37/Jumpman_logo.svg/1200px-Jumpman_logo.svg.png"
                    alt=""/>
                <img src="https://www.svgrepo.com/show/303123/bmw-logo.svg" alt=""/>
                <img src="https://brandlogos.net/wp-content/uploads/2014/12/starbucks_coffee_company-logo_brandlogos.net_9jqys.png"
                    alt=""/>
                <img src="https://www.zarla.com/images/nike-logo-2400x2400-20220504.png?crop=1:1,smart&width=150&dpr=2"
                    alt=""/>
                <img src="https://www.zarla.com/images/apple-logo-2400x2400-20220512-1.png?crop=1:1,smart&width=150&dpr=2"
                    alt=""/>
                <img src="https://www.zarla.com/images/disney-logo-2400x2400-20220513-2.png?crop=1:1,smart&width=150&dpr=2"
                    alt=""/>
                <img src="https://upload.wikimedia.org/wikipedia/en/thumb/4/4d/Loon_%28company%29_logo.svg/800px-Loon_%28company%29_logo.svg.png"
                    alt=""/>
                <img src="https://upload.wikimedia.org/wikipedia/en/thumb/3/37/Jumpman_logo.svg/1200px-Jumpman_logo.svg.png"
                    alt=""/>
                <img src="https://www.svgrepo.com/show/303123/bmw-logo.svg" alt=""/>
                <img src="https://brandlogos.net/wp-content/uploads/2014/12/starbucks_coffee_company-logo_brandlogos.net_9jqys.png"
                    alt=""/>


            </div>
        </div>
        </section>  

        </div>

      </div>
*/}
     
      <div className="call-blue text-center">

        <h2 className="text-white text-center mt-5">
          We are passionate about serving our clients !
        </h2>
        <h5 className="text-white text-center">Case Studies - Our successful campaigns</h5>

      </div>
      <div className="row">
        <div className="col-lg-4 col-md-6 col-sm-6">
          <div className="single-cat text-left mb-20">
            <img src={Swimming} className="img-fluid" alt="" />
            <div className="cat-cap">
              <h4 className="mt-3">
                <a href="services"><strong>Search Marketing Case Study: Pool Installation and Repairs</strong></a>
              </h4>

              <p className="mt-3">A South African company offering pool installation , pool building , pool repairs to pool cleaning
                services commissioned Akiltech’s services to setup it's digital footprint ,online presence , grow it’s rankings on Google and  increase engagement with its target audience across digital platforms. </p>
            </div>
            <a href={SwimmingPool} download="Swimming Pool Installation Capetown Case Study" className="btn mt-20">
              DOWNLOAD CASE STUDY <img src={Download} />
            </a>
          </div>
        </div>
        <div className="col-lg-4 col-md-6 col-sm-6">
          <div className="single-cat text-left mb-20">
            <img src={Carports} className="img-fluid" alt="" />
            <div className="cat-cap mt-3">
              <h4>
                <a href="services"><strong>Search Engine Optimization Case Study: Carports & Shadeports Contractors</strong></a>
              </h4>

              <p className="mt-3">A South African company providing residential and commercial carports and shadeports installation services in Western Cape. It commissioned Akiltech’s services to setup online presence, increase Google market share, rankings and online conversions. </p>
            </div>
            <a href={CarportCape} download="Carports-Capetown-Case-Study" className="btn mt-20">
              DOWNLOAD CASE STUDY <img src={Download} />
            </a>
          </div>
        </div>
        <div className="col-lg-4 col-md-6 col-sm-6">
          <div className="single-cat text-left mb-20">

            <img src={Khloe} className="img-fluid" alt="" />

            <div className="cat-cap mt-3">
              <h4>
                <a href={KhloHome} download="Khole-home-decor"><strong>Website Dev & GBM Case Study: Home Interiors | Curtains</strong></a>
              </h4>
              <p className="mt-3">
                Khloe's Home & Décor is a Zimbabwean private owned company specialising in Home Interiors.Core business is curtaining,  providing to both households and organisations. It was founded in 2017 by a young woman who had a passion for home decor and office improvements.Khloe commissioned Akiltech’s services to setup google and internet presence.
              </p>
            </div>
            <a href={KhloHome} download="Khole-home-decor Case Study" className="btn mt-20">
              DOWNLOAD CASE STUDY <img src={Download} />
            </a>
          </div>
        </div>
        <div className="col-lg-4 col-md-6 col-sm-6">
          <div className="single-cat text-left mb-20">

            <img src={Eastgate} className="img-fluid" alt="" />

            <div className="cat-cap mt-3">
              <h4>
                <a href="services"><strong>Website Dev Case Study: Pool Installation and Repairs</strong></a>
              </h4>
              <p>
                A Dental practice in Harare CBD which provides a full spectrum of dental services. It commissioned Akiltech’s services to setup it's digital footprint ,online presence and increase it’s visibility on Googele.
              </p>
            </div>
            <a href={EastgateDental} download="Eastgate Dental Case Study" className="btn mt-20">
              DOWNLOAD CASE STUDY <img src={Download} />
            </a>
          </div>
        </div>



      </div>
   

      <div
        style={{ marginTop: "0" }}
        className="count-down-area section-padding border-bottom"
      >
        {/* <!--End Your Project-->
      <!-- About Area  --> */}
        <section className="about-area2 section-padding white-bg">

          <div className="container">
            <div className="row align-items-center justify-content-between">
              <div className="col-xl-5 col-lg-5 col-md-10">
                {/* <!-- about-img --> */}
                <div className="about-img">
                  <img src="assets/img/gallery/about1.jpg" alt="" />
                </div>
                <div className="ratting-point">
                  <div className="features-ratting">
                    <img src="assets/img/icon/notification.svg" alt="" />
                  </div>
                  <div className="features-caption">
                    <h3>WE SPEAK BUSINESS, NOT JUST TECH</h3>
                    <p>we create relevant and engaging content</p>
                  </div>
                </div>
              </div>
              <div className="col-xl-5 col-lg-6 col-md-10">
                <div className="about-caption mb-50">
                  {/* <!-- Section Tittle --> */}
                  <div className="section-tittle mb-50">
                    <h2>
                      A Website That Doesn't
                      <br />
                      Bring  Client Is Useless
                    </h2>
                  </div>
                  <div className="single-offers mb-20">
                    <div className="offers-cap">
                      <img src="assets/img/icon/notification1.svg" alt="" />
                      <h3>
                        <a href="#digital_marketing">SEO – what’s the fuss?</a>
                      </h3>
                      <p>
                        Running a business and getting quality clients in today’s
                        competitive online landscape has become more difficult.To stay ahead, it's crucial to up your game when it comes to SEO. Without a strong SEO strategy in place, you risk fading into obscurity and falling behind the competition.</p>
                    </div>
                  </div>
                  <div className="single-offers">
                    <div className="offers-cap">
                      <img src="assets/img/icon/notification1.svg" alt="" />
                      <h3>
                        <a href="#google">Get A Custom Roadmap</a>
                      </h3>
                      <p>
                        With a concrete plan in place, we can elevate your online visibility and effectively direct customers to your website, exposing them to your products, services, and brand. Our top-notch SEO services are guaranteed to keep your phone ringing with potential customers. Schedule your consultation to meet with a member of our SEO team within a couple of business days.                      </p>
                    </div>
                  </div>
                  <a href="services" className="btn mt-20">
                    Schedule Free SEO Consulting
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>


        {/* <!-- About Area End -->
      <!--Services Area 2 --> */}
        <section className="services-area2 section-padding2">
          <div className="container">
            <div className="row align-items-center justify-content-between">
              <div className="col-xl-5 col-lg-5 col-md-6 col-sm-11">
                {/* <!-- Section Tittle --> */}
                <div className="section-tittle section-tittle2 mb-55">
                  <span>Industries We Serve</span>
                  <h2>Software Development services </h2>
                </div>
              </div>
              <div className="col-xl-5 col-lg-5 col-md-6 col-sm-11">
                {/* <!-- Section Tittle --> */}
                <div className="section-tittle section-tittle2 mb-55">
                  <p>
                    No matter the business, AkilTech has you covered with
                    industry compliant solutions, customized to your company’s
                    specific needs.
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-3 col-md-4 col-sm-6">
                <div className="single-cat mb-30 text-center">
                  <div className="cat-icon">
                    <img src="assets/img/icon/stack1.svg" alt="" />
                  </div>
                  <div className="cat-cap">
                    <h5>
                      <a href="#r">Industries & Manufacturing</a>
                    </h5>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-4 col-sm-6">
                <div className="single-cat mb-30 text-center">
                  <div className="cat-icon">
                    <img src="assets/img/icon/stack2.svg" alt="" />
                  </div>
                  <div className="cat-cap">
                    <h5>
                      <a href="#r">Education & Health</a>
                    </h5>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-4 col-sm-6">
                <div className="single-cat mb-30 text-center">
                  <div className="cat-icon">
                    <img src="assets/img/icon/stack3.svg" alt="" />
                  </div>
                  <div className="cat-cap">
                    <h5>
                      <a href="#r">Retail & Ecommerce</a>
                    </h5>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-4 col-sm-6">
                <div className="single-cat mb-30 text-center">
                  <div className="cat-icon">
                    <img src="assets/img/icon/stack4.svg" alt="" />
                  </div>
                  <div className="cat-cap">
                    <h5>
                      <a href="#e">Travel & Hospitality</a>
                    </h5>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-3 col-md-4 col-sm-6">
                  <div className="single-cat mb-30 text-center">
                    <div className="cat-icon">
                      <img src="assets/img/icon/stack1.svg" alt="" />
                    </div>
                    <div className="cat-cap">
                      <h5>
                        <a href="#s">Media and Entertainment</a>
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6">
                  <div className="single-cat mb-30 text-center">
                    <div className="cat-icon">
                      <img src="assets/img/icon/stack2.svg" alt="" />
                    </div>
                    <div className="cat-cap">
                      <h5>
                        <a href="#a">Public Services & FinTech</a>
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6">
                  <div className="single-cat mb-30 text-center">
                    <div className="cat-icon">
                      <img src="assets/img/icon/stack3.svg" alt="" />
                    </div>
                    <div className="cat-cap">
                      <h5>
                        <a href="#a"> Software as a Service & SMEs</a>
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6">
                  <div className="single-cat mb-30 text-center">
                    <div className="cat-icon">
                      <img src="assets/img/icon/stack4.svg" alt="" />
                    </div>
                    <div className="cat-cap">
                      <h5>
                        <a href="#a">Agriculture & Real Estate</a>
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col-xl-12">
                  <div className="section-tittle section-tittle3 text-center pt-35">
                    <p>
                      Need a Technology support or to discuss a project ?{" "}
                      <a href="request">Get Started Now</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Apply2 />
      </div>


      <TopFooter />
    </main>
  );
};

export default Home;
